import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=00c8ea9f"
var script = {}
import style0 from "./HomeView.vue?vue&type=style&index=0&id=00c8ea9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports